import { CognitoUserPool } from 'amazon-cognito-identity-js'
import { validateCognitoConfig } from '@brent/shared'

const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID
const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID
const region = import.meta.env.VITE_COGNITO_REGION || 'eu-west-1'
const domain = import.meta.env.VITE_COGNITO_DOMAIN || undefined

// Validate configuration
export const cognitoConfig = validateCognitoConfig({
  userPoolId,
  clientId,
  region,
  domain,
})

// Create user pool instance
export const userPool = new CognitoUserPool({
  UserPoolId: cognitoConfig.userPoolId,
  ClientId: cognitoConfig.clientId,
})

// Cognito domain for OAuth flows (optional - only set when Google IdP is configured)
export const cognitoDomain = cognitoConfig.domain || null
export const cognitoClientId = cognitoConfig.clientId
